import React from "react";

const AccessPending = ({ feature = "PlaysWithGuru", reason, title = "Access Pending" }) => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ maxWidth: 520, padding: 24, textAlign: "center" }}>
        <h2 style={{ marginBottom: 12 }}>{title}</h2>
        <p style={{ marginBottom: 12, lineHeight: 1.5 }}>
          {reason || `Your account is active, but access to ${feature} is not enabled yet.`}
        </p>
        <p style={{ fontSize: 13, opacity: 0.75, lineHeight: 1.5 }}>
          PlaysWithGuru is currently in private beta. Access is granted manually to keep quality high.
        </p>
      </div>
    </div>
  );
};

export default AccessPending;
